import { useEffect } from 'react'
import { useDebounce } from './useDebounce';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height, scrollY: scrollY, scrollX: scrollX } = window;
  return {
    width,
    height,
    scrollX,
    scrollY
  };
}
  
export function useWindowDimensions() {
  
  const [debouncedValue, value, setValue] = useDebounce( getWindowDimensions() , 50)

  useEffect(() => {

    const debouncedHandleResize = () =>{
      setValue(getWindowDimensions())
    }

    // const debouncedHandleScroll = debounce(function handleScroll(){
    //   setWindowDimensions(getWindowDimensions());
    // }, 100)

    window.addEventListener('resize', debouncedHandleResize);
    
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    }
  }, []);

    return debouncedValue;
}
  